/* Wrist-fit highlight — extracted from snippets/watch-fit-highlight.liquid (Sep 2026).
   12KB of identical script that was inlined into every product page. No Liquid in it,
   so it moves out whole and is now fetched once and cached across every PDP. */
(function () {
  if (window.__mgbWatchFitHighlight) return;
  window.__mgbWatchFitHighlight = true;

  var KEY = 'mgb_watch_fit_v7_cf';
  var OPTION_RE = /lug\s*width/i;
  // Native <option> text is the only thing we can change in a dropdown, so
  // the tick is what makes the customer's row stand out in the open list.
  var MARK_FITS = ' — ✓ Fits your ';
  var MARK_PLAIN = ' — Fits your ';   // no tick when it can't be bought here
  var userOverride = false;   // set once the customer picks a width themselves
  var observer = null;
  // Selecting the width for the customer is only ever safe when nothing else
  // is changing the variant. Doing it in response to Dawn's own re-render
  // (a colour change, say) fires a second request that can be built from a
  // half-swapped DOM — new width, previous colour — which lands the customer
  // back on the colour they just moved away from.
  var autoSelectArmed = true;
  // Selecting the size on page load means asking Shopify to re-render the
  // section. That request races anything the customer does in the next
  // half-second: click a colour while it is in flight and the older response
  // lands last, snapping them back to the colour they started on — two
  // renders and a revert. Choosing a watch is race-free (nothing else is in
  // flight), so that path still selects for them. Set this to true only if
  // you would rather have the load-time selection and accept the race.
  var AUTO_SELECT_ON_LOAD = false;

  function safeParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function readFit() {
    var d = safeParse(localStorage.getItem(KEY));
    if (!d) return null;
    var lug = String(d.lugWidth == null ? '' : d.lugWidth).replace(/mm/i, '').trim();
    if (!lug) return null;
    var n = parseFloat(lug);
    if (!isNaN(n)) lug = String(n % 1 === 0 ? n.toFixed(0) : n);
    d.lug = lug;
    return d;
  }
  function watchName(fit) {
    var parts = [];
    if (fit.brand) parts.push(String(fit.brand).trim());
    if (fit.model) parts.push(String(fit.model).trim());
    return parts.join(' ') || String(fit.reference || '').trim() || 'watch';
  }
  function normLug(v) {
    var s = String(v == null ? '' : v).replace(/mm/i, '').trim();
    var n = parseFloat(s);
    return isNaN(n) ? s.toLowerCase() : String(n % 1 === 0 ? n.toFixed(0) : n);
  }
  function labelFor(select) {
    var wrap = select.closest('.product-form__input');
    var label = wrap && wrap.querySelector('label, legend');
    return label ? label.textContent : '';
  }
  function lugSelects() {
    return Array.prototype.filter.call(
      document.querySelectorAll('variant-selects select, .product-form__input--dropdown select'),
      function (s) { return OPTION_RE.test(s.getAttribute('name') || '') || OPTION_RE.test(labelFor(s)); }
    );
  }
  function baseText(option) {
    var stored = option.getAttribute('data-mgb-base');
    if (stored !== null) return stored;
    var text = (option.textContent || '').trim();
    option.setAttribute('data-mgb-base', text);
    return text;
  }
  function isUnavailable(option) {
    return /unavailable|sold\s*out/i.test(baseText(option));
  }

  function openChecker() {
    var opener = document.querySelector('[data-mgb-strap-checker-open]');
    if (opener) { opener.click(); return; }
    var finder = document.querySelector('[data-strap-finder]');
    if (finder) finder.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function textNode(s) { return document.createTextNode(s); }
  function lineNode(nodes) {
    var line = document.createElement('span');
    line.className = 'mgb-fit-note__line';
    nodes.forEach(function (n) { line.appendChild(n); });
    return line;
  }
  function refNode(s) {
    var el = document.createElement('span');
    el.className = 'mgb-fit-note__ref';
    el.textContent = s;
    return el;
  }
  function watchNode(s) {
    var el = document.createElement('span');
    el.className = 'mgb-fit-note__watch';
    el.textContent = s;
    return el;
  }
  function actionsNode(actions) {
    var row = document.createElement('span');
    row.className = 'mgb-fit-note__actions';
    actions.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mgb-fit-note__action';
      b.textContent = a.label;
      b.addEventListener('click', a.onClick);
      row.appendChild(b);
    });
    return row;
  }

  // Only rebuilds when the message actually changes, so the buttons keep
  // their identity between renders and stay clickable.
  function renderNote(wrap, signature, build) {
    var existing = wrap.firstChild && wrap.firstChild.classList
      && wrap.firstChild.classList.contains('mgb-fit-note') ? wrap.firstChild : null;
    if (!existing) {
      existing = wrap.querySelector('.mgb-fit-note');
    }
    if (!signature) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing && existing.getAttribute('data-mgb-sig') === signature) return;
    if (existing) existing.parentNode.removeChild(existing);
    var note = build();
    note.setAttribute('data-mgb-sig', signature);
    // Directly under the dropdown, so it reads as part of the Lug Width picker:
    // the answer to "does the width I've selected fit my watch?".
    var anchor = wrap.querySelector('.select');
    if (anchor && anchor.parentNode === wrap) {
      wrap.insertBefore(note, anchor.nextSibling);
    } else {
      wrap.appendChild(note);
    }
  }

  function noteEl(kind, iconChar, nodes) {
    var note = document.createElement('div');
    note.className = 'mgb-fit-note' + (kind === 'warn' ? ' mgb-fit-note--warn' : '');
    note.setAttribute('role', 'status');
    var icon = document.createElement('span');
    icon.className = 'mgb-fit-note__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = iconChar;
    var text = document.createElement('div');
    text.className = 'mgb-fit-note__text';
    nodes.forEach(function (n) { text.appendChild(n); });
    note.appendChild(icon);
    note.appendChild(text);
    return note;
  }

  function selectOption(select, option) {
    select.value = option.value;
    // VariantSelects listens on the container and moves the `selected`
    // attribute itself, which is what Dawn reads when it builds the variant.
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyToSelect(select, fit, allowAutoSelect) {
    var wrap = select.closest('.product-form__input') || select.parentNode;
    var options = Array.prototype.slice.call(select.options);
    var name = fit ? watchName(fit) : '';
    var match = null;
    if (fit) {
      for (var i = 0; i < options.length; i++) {
        if (normLug(options[i].value) === fit.lug) { match = options[i]; break; }
      }
    }

    // Label the customer's row. Writing only on change is what stops this
    // script from re-triggering its own observer.
    options.forEach(function (o) {
      var want = baseText(o);
      if (fit && o === match) {
        want += (isUnavailable(o) ? MARK_PLAIN : MARK_FITS) + name;
      }
      if (o.textContent !== want) o.textContent = want;
    });

    if (!fit) { renderNote(wrap, '', null); return; }

    var changeWatch = { label: 'Change watch', onClick: openChecker };

    var selectedLabel = baseText(select.options[select.selectedIndex] || options[0] || { textContent: select.value });

    if (!match) {
      renderNote(wrap, 'missing|' + select.value + '|' + fit.lug + '|' + name, function () {
        return noteEl('warn', '!', [
          lineNode([
            textNode(selectedLabel + ' won’t fit your '),
            watchNode(name),
            textNode('. It needs ' + fit.lug + 'mm, and this strap doesn’t come in that size.')
          ]),
          actionsNode([changeWatch])
        ]);
      });
      return;
    }

    if (isUnavailable(match)) {
      var onIt = normLug(select.value) === fit.lug;
      renderNote(wrap, 'unavailable|' + select.value + '|' + fit.lug + '|' + name, function () {
        return noteEl('warn', '!', [
          lineNode(onIt ? [
            textNode(fit.lug + 'mm fits your '),
            watchNode(name),
            textNode(', but isn’t available in this colour. Try another colour.')
          ] : [
            textNode(selectedLabel + ' won’t fit your '),
            watchNode(name),
            textNode('. It needs ' + fit.lug + 'mm, which isn’t available in this colour.')
          ]),
          actionsNode([changeWatch])
        ]);
      });
      return;
    }

    var current = normLug(select.value);
    if (current !== fit.lug && !userOverride && allowAutoSelect && autoSelectArmed) {
      autoSelectArmed = false;   // one variant request, never a chain
      selectOption(select, match);
      // Draw the confirmation now rather than waiting on Dawn's re-render.
      // If it does re-render, the observer simply draws it again.
      current = fit.lug;
    }

    if (current === fit.lug) {
      renderNote(wrap, 'ok|' + fit.lug + '|' + name + '|' + (fit.reference || ''), function () {
        return noteEl('ok', '✓', [
          lineNode([
            textNode(fit.lug + 'mm fits your '),
            watchNode(name)
          ]),
          fit.reference ? refNode('Ref ' + fit.reference) : textNode(''),
          actionsNode([changeWatch])
        ]);
      });
    } else {
      renderNote(wrap, 'mismatch|' + select.value + '|' + fit.lug + '|' + name, function () {
        return noteEl('warn', '!', [
          lineNode([
            textNode(selectedLabel + ' won’t fit your '),
            watchNode(name),
            textNode('. It needs ' + fit.lug + 'mm.')
          ]),
          actionsNode([
            { label: 'Use ' + fit.lug + 'mm', onClick: function () {
              userOverride = false;
              selectOption(select, match);
            } },
            changeWatch
          ])
        ]);
      });
    }
  }

  function apply(allowAutoSelect) {
    var selects = lugSelects();
    if (!selects.length) return;
    var fit = readFit();
    if (observer) observer.disconnect();
    try {
      selects.forEach(function (select) { applyToSelect(select, fit, allowAutoSelect === true); });
    } finally {
      if (observer) {
        observer.takeRecords();   // drop anything we caused ourselves
        observe();
      }
    }
  }

  // The customer touching ANY option outranks us. Disarming here matters as
  // much as the loop guard: our load-time request can still be in flight when
  // they click a colour, and if we then queue another one, the older response
  // lands last and drags them back to the colour they started on.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !e.isTrusted) return;
    if (!t.closest || !t.closest('variant-selects')) return;
    autoSelectArmed = false;
    if (t.tagName === 'SELECT' && OPTION_RE.test(t.getAttribute('name') || '')) {
      userOverride = true;
    }
  }, true);

  var scheduled = false;
  var scheduledAuto = false;
  function schedule(allowAutoSelect) {
    if (allowAutoSelect) scheduledAuto = true;
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      var auto = scheduledAuto;
      scheduled = false;
      scheduledAuto = false;
      apply(auto);
    }, 60);
  }
  var host = document.querySelector('product-info') || document.body;
  function observe() {
    if (observer) observer.observe(host, { childList: true, subtree: true });
  }
  if (window.MutationObserver) {
    // Wrapped, not passed directly: the observer hands its callback the
    // mutation list, which would arrive as a truthy `allowAutoSelect` and
    // re-enable the very behaviour this guard exists to prevent.
    observer = new MutationObserver(function () { schedule(false); });
    observe();
  }

  // A new watch is a deliberate act, so re-arm and let it pick the size.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    userOverride = false;
    autoSelectArmed = true;
    schedule(true);
  });
  document.addEventListener('mgb:watch-fit-change', function () {
    userOverride = false;
    autoSelectArmed = true;
    schedule(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(AUTO_SELECT_ON_LOAD); });
  } else {
    apply(AUTO_SELECT_ON_LOAD);
  }
})();
